import React from 'react';
import { apiCall } from '../common/common';
import { displayLog } from '../common/common';

//config
import config from "../config";
import Axios from 'axios';

const ReferralContext = React.createContext();


const rootReducer = (state, action) => {
    switch (action.type) {
        case "GET_REFERRAL_CODE_DATA":
            return {
                isLoaded: true,
                allReferralState: action.payload.data,
                UserData: {}
            };
        case "SET_REFERRAL_CODE_DATA":
            return {
                isLoaded: true,
                allReferralState: action.payload,
                UserData: {}
            };
        case "SET_ACTIVE_STATUS_CHANGE":
            return {
                isLoaded: true,
                UserData: {}
            };
        case "SET_DELETE_REFERRAL_CODE":
            return {
                isLoaded: true,
                UserData: {}
            };
        case 'REQUEST_CALLED':
            return {
                isLoaded: false,
                allReferralState: [],
                UserData: {}
            }
        case 'GET_REFERRAL_DATA_BY_ID':
            return {
                isLoaded: true,
                allReferralState: [],
                UserData: action.payload.data
            }
        default:
            return {
                ...state
            };
    }
};

const ReferralCodeDataProvider = ({ children }) => {

    const [AllReferralData, setAllReferralData] = React.useReducer(rootReducer, {
        isLoaded: false,
        allReferralState: [],
        UserData: {}
    });

    return (
        <ReferralContext.Provider value={{
            AllReferralData, setAllReferralData
        }}>
            {children}
        </ReferralContext.Provider>
    );
};

const ReferralState = () => {
    const context = React.useContext(ReferralContext);
    return context;
};



//API call to set Help content 
export const getReferralDatas = async (dispatch) => {
    let response = await apiCall('GET', 'GET_REFERRAL_CODE_DATA', '/admin/getReferralCodeList', {}, {}, {}, dispatch)
    dispatch({ type: "REQUEST_CALLED" });
    if (response && response.data) {
        if (response.data.code === 0) {
            displayLog(0, response.data.message)
        } else {
            dispatch({ type: "GET_REFERRAL_CODE_DATA", payload: response.data });
        }
    }
};

export const addReferralData = async (dispatch, reqData) => {
    dispatch({ type: "REQUEST_CALLED" });
    let response = await apiCall('POST', 'SET_REFERRAL_CODE_DATA', '/admin/addSubscriptionReferralCode', reqData, {}, {}, dispatch)
    if (response && response.data) {
        if (response.data.code === 0) {
            displayLog(0, response.data.message)
        } else {
            dispatch({ type: "SET_REFERRAL_CODE_DATA", payload: response.data });
        }
    }
};

export const editReferralData = async (dispatch, reqData) => {
    dispatch({ type: "REQUEST_CALLED" });
    let response = await apiCall('POST', 'SET_REFERRAL_CODE_DATA', '/admin/updateReferralCode', reqData, {}, {}, dispatch)
    if (response && response.data) {
        if (response.data.code === 0) {
            displayLog(0, response.data.message)
        } else {
            dispatch({ type: "SET_REFERRAL_CODE_DATA", payload: response.data });
        }
    }
};

export const handleActiveStatusChange = async (dispatch, reqData) => {
    let response = await apiCall('POST', 'SET_REFERRAL_CODE_DATA', '/admin/activeDeactiveCode', reqData, {}, {}, dispatch)
    if (response && response.data) {
        if (response.data.code === 0) {
            displayLog(0, response.data.message)
        } else {
            dispatch({ type: "SET_ACTIVE_STATUS_CHANGE" });
        }
    }
};

export const handleDeleteReferralCode = async (dispatch, reqData) => {
    let response = await apiCall('POST', 'SET_REFERRAL_CODE_DATA', '/admin/deleteReferralCode', reqData, {}, {}, dispatch)
    if (response && response.data) {
        if (response.data.code === 0) {
            displayLog(0, response.data.message)
        } else {
            dispatch({ type: "SET_DELETE_REFERRAL_CODE" });
        }
    }
};

export const getRefarralDatabyID = async (dispatch, reqData) => {
    dispatch({ type: "REQUEST_CALLED" });
    let response = await apiCall('POST', 'SET_REFERRAL_CODE_DATA', '/admin/getReferralCodeById', reqData, {}, {}, dispatch)
    if (response && response.data) {
        if (response.data.code === 0) {
            displayLog(0, response.data.message)
        } else {
            dispatch({ type: "GET_REFERRAL_DATA_BY_ID", payload: response.data });
        }
    }
};



export { ReferralCodeDataProvider, ReferralContext, ReferralState };
